module.exports = __webpack_public_path__ + "img/base_expand_arrow.319772f2.svg";